module.exports = __webpack_public_path__ + "media/images/front/icon_popular_01-ae47697d35c1d8ef21812a3bf9dfbce4.svg";